import { format, startOfDay } from 'date-fns';
import { isWithinInterval } from 'date-fns/isWithinInterval';
import { parseISO } from 'date-fns/parseISO';
import { subHours } from 'date-fns/subHours';

export const today = startOfDay(new Date());

export function isWithinLast24Hours(date: Date) {
  const nowMinus24h = subHours(new Date(), 24);
  return isWithinInterval(date, {
    start: nowMinus24h,
    end: new Date(),
  });
}

export function toDate(date: string | Date | null) {
  return date ? (date instanceof Date ? date : parseISO(date)) : null;
}

export function formatShortDate(date: Date | string) {
  return format(date, 'LLL dd, y');
}

export function durationInDays(
  startDate: string | Date,
  endDate: string | Date,
) {
  return Math.round(
    (new Date(endDate).getTime() - new Date(startDate).getTime()) /
      (1000 * 60 * 60 * 24),
  );
}
